export interface RemoteResource {
  presignedUrl: string;
  uuid: string;
}
